import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-import-user",
  templateUrl: "./import-user.component.html",
  styleUrls: ["./import-user.component.scss"],
})
export class ImportUserComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
